import React from "react";

const BREITE = 900;
const HOEHE = 260;
const ACHSE_Y = 150;
const ACHSE_START = 40;
const ACHSE_ENDE = 860;

// Schematische Positionen entlang der Achse (0..1) - keine echten Datumswerte,
// sondern die typische zeitliche Reihenfolge: heute, T ideal (mit Vorlauf aus
// Wiederbeschaffung + Sicherheitspuffer bis zur Ankunft), T kritisch, T spät,
// T leer. Eine Liefergelegenheit nach T spät zeigt die Warnung "zu spät".
const PUNKTE = [
    {pos: 0.04, label: "Heute", farbe: "#212529", oben: false},
    {pos: 0.26, label: "T ideal", zeile2: "hier bestellen", farbe: "#20c997", oben: true},
    {pos: 0.4, label: "Ankunft", zeile2: "geplante Lieferung", farbe: "#0d6efd", oben: false, liefer: true},
    {pos: 0.55, label: "T kritisch", zeile2: "Sicherheitsbestand erreicht", farbe: "#fd7e14", oben: true},
    {pos: 0.74, label: "T spät", zeile2: "letzte Gelegenheit", farbe: "#e8590c", oben: false},
    {pos: 0.86, label: "nächstes Fenster", zeile2: "kommt zu spät", farbe: "#dc3545", oben: true, liefer: true, warnung: true},
    {pos: 0.97, label: "T leer", zeile2: "Artikel ist aus", farbe: "#dc3545", oben: false},
];

function x(pos) {
    return ACHSE_START + pos * (ACHSE_ENDE - ACHSE_START);
}

/**
 * Eigenes, schematisches SVG "Die vier Marken" (Folie 5, Auftrag S7) - anders
 * als der reale Zeitstrahl im Artikel-Blatt (recharts, echte Tageswerte) ist
 * dies eine allgemeingültige Erklärung der Reihenfolge und Bedeutung der vier
 * Marken plus der Warnung "nächstes Fenster zu spät", unabhängig von einem
 * einzelnen Farbton.
 */
export default function MarkenZeitstrahlSchaubild() {
    return (
        <svg viewBox={`0 0 ${BREITE} ${HOEHE}`} role="img" aria-label="Schematischer Zeitstrahl mit den vier Marken T ideal, T kritisch, T spät und T leer sowie der Warnung, wenn das nächste Lieferfenster zu spät kommt." style={{width: "100%", height: "auto", maxWidth: 820, minWidth: 640}}>
            <defs>
                <marker id="marken-pfeil" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
                    <path d="M0,0 L8,4 L0,8 Z" fill="#495057" />
                </marker>
            </defs>

            <line x1={ACHSE_START} y1={ACHSE_Y} x2={ACHSE_ENDE + 14} y2={ACHSE_Y} stroke="#495057" strokeWidth={2} markerEnd="url(#marken-pfeil)" />
            <text x={ACHSE_ENDE + 16} y={ACHSE_Y + 4} fontSize={11} fill="#495057">
                Zeit
            </text>

            {/* Vorlaufklammer Wiederbeschaffungszeit + Sicherheitspuffer zwischen T ideal und Ankunft -
                deutlich oberhalb der zweizeiligen "T ideal"-Beschriftung platziert (Befund S6,
                Sichtprüfung 3: die Klammer lag vorher auf derselben Höhe wie "hier bestellen" und
                überlappte sowohl den Marken-Text als auch sich selbst) */}
            <line x1={x(0.26)} y1={ACHSE_Y - 88} x2={x(0.4)} y2={ACHSE_Y - 88} stroke="#0d6efd" strokeWidth={1.5} strokeDasharray="3 3" />
            <text x={(x(0.26) + x(0.4)) / 2} y={ACHSE_Y - 94} fontSize={11} fill="#0d6efd" textAnchor="middle">
                Wiederbeschaffung + Sicherheitspuffer
            </text>

            {PUNKTE.map((p) => (
                <g key={p.label}>
                    <line x1={x(p.pos)} y1={ACHSE_Y - 10} x2={x(p.pos)} y2={ACHSE_Y + 10} stroke={p.farbe} strokeWidth={2} />
                    <circle cx={x(p.pos)} cy={ACHSE_Y} r={4} fill={p.farbe} />
                    {p.liefer && (
                        <text x={x(p.pos)} y={ACHSE_Y + (p.oben ? 34 : -20)} fontSize={16} textAnchor="middle" aria-hidden="true">
                            🚚
                        </text>
                    )}
                    <text x={x(p.pos)} y={p.oben ? ACHSE_Y - 62 : ACHSE_Y + 30} fontSize={13} fontWeight={700} fill={p.farbe} textAnchor="middle">
                        {p.label}
                    </text>
                    {p.zeile2 && (
                        <text x={x(p.pos)} y={(p.oben ? ACHSE_Y - 62 : ACHSE_Y + 30) + 16} fontSize={11} fill="#6c757d" textAnchor="middle">
                            {p.zeile2}
                        </text>
                    )}
                </g>
            ))}

            <rect x={x(0.63)} y={ACHSE_Y + 60} width={280} height={40} rx={6} fill="#fff5f5" stroke="#dc3545" />
            <text x={x(0.63) + 140} y={ACHSE_Y + 78} fontSize={11} fontWeight={600} fill="#842029" textAnchor="middle">
                „Nächstes Fenster zu spät“ –
            </text>
            <text x={x(0.63) + 140} y={ACHSE_Y + 94} fontSize={11} fill="#842029" textAnchor="middle">
                dann hilft nur noch Umdisponieren
            </text>
        </svg>
    );
}
